import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems, differenceStats } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-45" data-mp="a5t49fsozck">
      <div className="mx-auto max-w-5xl" data-id="element-46" data-mp="9vz8armq81l">
        <div className="mx-auto max-w-3xl text-center" data-id="element-47" data-mp="58z5tzn9cmbo">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-48" data-mp="57ebob4uv5ec">
            La Differenza di INGLESE PRONTO™
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-ink sm:text-5xl" data-id="element-49" data-mp="3rgyrl5j7ekde">
            Da insegnante esausto a{' '}
            <span className="italic text-brand" data-id="element-50" data-mp="3diqv0yq2xl2r">guida sicura di sé.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-51" data-mp="3ig0sn1nmh31o">
            Dai alle tue lezioni un ritmo chiaro, ai tuoi studenti più fiducia
            linguistica e a te stesso il tempo di goderti di nuovo
            l&apos;insegnamento.
          </p>
        </div>

        <dl className="mx-auto mt-11 grid max-w-3xl grid-cols-1 overflow-hidden rounded-xl border border-ink/10 bg-white sm:grid-cols-3" data-id="element-52" data-mp="1j92ncym2i3vm">
          {differenceStats.map((stat, index) => <div key={stat.label} className={`px-6 py-7 text-center ${index > 0 ? 'border-t border-ink/10 sm:border-l sm:border-t-0' : ''}`} data-id="element-53" data-mp="1t070dss6nent" data-mpi={index}>
              <dt className="sr-only" data-id="element-54" data-mp="wb7v8mmwaszu">{stat.label}</dt>
              <dd data-id="element-55" data-mp="wcsom8xh45w4">
                <span className="block font-display text-3xl font-black text-brand" data-id="element-56" data-mp="1aah9hgrjjd16">
                  {stat.value}
                </span>
                <span className="mt-1.5 block text-[10px] font-bold uppercase tracking-[0.14em] text-ink/50" data-id="element-57" data-mp="15acopejlnw55">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-58" data-mp="2gqb4s2d73ifv">
          <div className="grid md:grid-cols-2" data-id="element-59" data-mp="2oqh34k4qt1sg">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-60" data-mp="2ssu9narbd3qa">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-ink/40" data-id="element-61" data-mp="2sr9fvnctpoth">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-62" data-mp="32r08fjhtptqx" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-ink/45" data-id="element-63" data-mp="32ontlf7d3zi3">
                Prima di Inglese Pronto
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-64" data-mp="2a34f8orgqjyw">
                Il costo dell&apos;improvvisazione
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-65" data-mp="2jsxrzt3cd54q">
                {beforeItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-white/70 px-4 py-3 text-sm text-ink/65" data-id="element-66" data-mp="1mbqq0rolz4i5">
                    <CircleXIcon className="h-4 w-4 shrink-0 text-ink/35" aria-hidden="true" data-id="element-67" data-mp="1jslv6ixg9qgo" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-68" data-mp="19vze8588vjjx">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-brand text-white" data-id="element-69" data-mp="14u9zaehwilqk">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-70" data-mp="10vazt9exvh6i" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-71" data-mp="w0wxen1v09sc">
                Con Inglese Pronto
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold uppercase leading-tight tracking-wide text-ink" data-id="element-72" data-mp="m5mw61jac6fm">
                Il sistema INGLESE PRONTO™
              </h3>
              <ul className="mt-7 space-y-3" data-id="element-73" data-mp="d3ner84cz0c5">
                {afterItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl bg-brand-light/60 px-4 py-3 text-sm font-medium text-ink" data-id="element-74" data-mp="11u1id0olnduw">
                    <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-75" data-mp="t2rb66knnj7q" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-ink/5 bg-cream/60 px-6 py-4 text-center text-xs text-ink/50" data-id="element-76" data-mp="o34xxx4tu2yx">
            Un sistema completo per pianificare meno e insegnare con più scopo.
          </p>
        </div>
      </div>
    </section>;
}